// Draws the test valley: the course's bodies (sim/view.ts), the pond's water as a flat translucent sheet, the hero
// and the mount as capsules (placeholders: the figure stream builds the Wanderer). The camera is @rpg/camera's rig
// (./camera.ts). View only: reads the sim, never writes it.
import * as THREE from "three";
import type { BodySpec, CollisionWorld } from "@rpg/collision";
import { createSimView } from "../sim/view";

const COLOUR: Record<string, string> = { terrain: "#86b35a", hero: "#e8a33c", mount: "#7a5230", sand: "#e3cf8f", inside: "#a59a88" };

export function createValleyView(parent: THREE.Object3D, bodies: readonly BodySpec[], collision: CollisionWorld): () => void {
  const draw = createSimView(parent, bodies, collision, (b) => {
    if (b.id === "terrain") return COLOUR.terrain;
    if (b.id === "hero") return COLOUR.hero;
    if (b.id === "mount") return COLOUR.mount;
    if (b.id === "sand") return COLOUR.sand;
    if (b.id.startsWith("step-") || b.id.startsWith("ramp-")) return b.id.endsWith("-top") || b.id.startsWith("step-") ? "#b8a98e" : "#c79b62";
    return undefined;
  });
  const water = new THREE.Group();
  water.name = "valley-water";
  for (const w of collision.waterVolumes()) {
    const sheet = new THREE.Mesh(
      new THREE.PlaneGeometry(w.max.x - w.min.x, w.max.z - w.min.z).rotateX(-Math.PI / 2),
      new THREE.MeshLambertMaterial({ color: "#4f8fc0", transparent: true, opacity: 0.55, depthWrite: false }),
    );
    sheet.position.set((w.min.x + w.max.x) / 2, (w.surface ?? w.max.y) + 0.01, (w.min.z + w.max.z) / 2);
    water.add(sheet);
  }
  parent.add(water);
  return draw;
}
